import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
import { CustomCertificateComponent } from './custom-certificate.component';
import { CustomCertificateService } from './services/custom-certificate.service';
import { PasswordModalComponent } from './password-modal/password-modal';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    CustomCertificateComponent,
    PasswordModalComponent
  ],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    SharedModule
  ],
  exports: [
    CustomCertificateComponent
  ],
  providers: [
    CustomCertificateService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomCertificateModule { }
